export default __webpack_public_path__ + "static/media/germ_rookie_badge_small@3x.8043d17c.png";